// Component to render customer contact details (name, email, mobile)
import React from 'react';
import { Typography, Box } from '@mui/material';
import { Email as EmailIcon, Phone as PhoneIcon } from '@mui/icons-material';

const CustomerContact = ({ contact }) => {
  if (!contact) return null;

  return (
    <Box>
      {/* Contact Name */}
      <Typography 
        variant="body2" 
        fontWeight="medium" 
        sx={{ mb: 0.5 }}
      >
        {contact.name || 'N/A'}
      </Typography>
      
      {/* Email */}
      {contact.email && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
          <EmailIcon fontSize="small" sx={{ color: 'primary.main', fontSize: 16 }} />
          <Typography variant="caption" color="textSecondary">
            {contact.email}
          </Typography>
        </Box>
      )}
      
      {/* Mobile */}
      {contact.mobile && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <PhoneIcon fontSize="small" sx={{ color: 'primary.main', fontSize: 16 }} />
          <Typography variant="caption" color="textSecondary">
            {contact.mobile}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default CustomerContact;  